import { Injectable, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from "@angular/http";

import { Subject } from "rxjs/Subject";

import "rxjs/Rx";

import { iUser } from "../../interfaces/security/iUser";
import { LocalStorageService } from "../shared/localStorage.service";
import { Router } from "@angular/router";
import { tokenNotExpired } from "angular2-jwt";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs/Observable";
import { SafeMethodCall } from '@angular/compiler';
import { iResponseInfo } from '../../interfaces/shared/iResponseInfo';
import { forEach } from '@angular/router/src/utils/collection';


@Injectable()
export class AuthService implements OnInit {
  private user: iUser = null;

  private returnUrl: string = null;

  private errorMessage: string = null;

  authenticationChanged = new Subject();
  passwordChanged = new Subject();
  passwordChangedReset = new Subject();
  passwordReset = new Subject();


  constructor(private http: Http,
    private lsService: LocalStorageService,
    private router: Router) { }

  ngOnInit() {
    if (tokenNotExpired()) {
      this.user = (<iUser>this.lsService.getCurrentUser());
    } else {
      this.user = null;
    }

    this.authenticationChanged.next();
 
  }

  isAuthenticated() {
    return tokenNotExpired();
  }

  login(username: string, password: string, rememberMe: boolean, returnUrl: string) {
    this.errorMessage = null;

    this.returnUrl = returnUrl;

    const qs = environment.apiPath + '/api/auth/login?username=' + username + '&password=' + password;

    return this.http.get(qs)
      .map(
        (response: Response) => {
          return response.json();
        })
      .subscribe(
        (response: any) => {
          if (response.responseInfo.isError) {

            this.user = null;
            this.lsService.removeCurrentUser();
            this.errorMessage = response.responseInfo.message;
          
          }
          else {

            this.user = response;
            this.lsService.setCurrentUser(this.user)
            this.errorMessage = null;

            this.lsService.rememberUser(username, password, rememberMe);
          }

          this.authenticationChanged.next();

        },
        (error: Error) => {
          this.user = null;
          this.lsService.removeCurrentUser();
          this.errorMessage = this.getExceptionMessage(error);
          this.authenticationChanged.next();
        });

  }

  private getExceptionMessage(error: Error) {
    if (environment.debugLevel == 0 || error == undefined || error == null || error.message == undefined || error.message == null || error.message == "") {
      return 'There was an error on the server and we could not authenticate you. Please contact your service administrator.';
    }
    else {
      return 'There was an error on the server and we could not authenticate you. Please contact your service administrator. [' + error.message + ']';
    }
  }

  changePassword(oldPassword: string, newPassword: string) {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getToken()
    });
    let options = new RequestOptions({ headers: headers });
    let postObj = {
      'userId': this.getUser().appUserId,
      'oldPassword': oldPassword,
      'newPassword': newPassword
    };

    var qs = environment.apiPath + '/api/auth/changePassword';

    return this.http.post(qs, postObj, options)
      .map(
        (response: Response) => {
          return response.json();
        }).subscribe(
          (response: any) => {
            this.passwordChanged.next(response.responseInfo);
          });
  }

  changeResetPassword(newPassword: string, resetPwdParam: string) {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getToken()
    });
    let options = new RequestOptions({ headers: headers });
    let postObj = {
      'userId': 0,
      'oldPassword': resetPwdParam,
      'newPassword': newPassword
    };

    var qs = environment.apiPath + '/api/auth/changeResetPassword';

    return this.http.post(qs, postObj, options)
      .map(
        (response: Response) => {
          return response.json();
        }).subscribe(
          (response: any) => {
            this.user.forcePasswordReset = false;
            this.lsService.setCurrentUser(this.user)

            this.passwordChangedReset.next(response.responseInfo);
          });
  }

  resetPassword(username: string, currentHref: string) {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getToken()
    });
    let options = new RequestOptions({ headers: headers });
    let postObj = {
      'userName': username,
      'currentHref': currentHref
    };

    var qs = environment.apiPath + '/api/auth/resetPassword';

    return this.http.post(qs, postObj, options)
      .map(
        (response: Response) => {
          return response.json();
        })
      .subscribe(
        (response: any) => {
          this.passwordReset.next(response);
        },
        (error: Error) => {
          this.passwordReset.next(null);
        });
  }


  agreeToTermsOfService() {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.getToken()
    });
    let options = new RequestOptions({ headers: headers });

    let postObj = {
      'AppUserId': this.user.appUserId,
      'IsAgreed': true
    };

    var qs = environment.apiPath + '/api/auth/UpdateTermsOfService';

    return this.http.post(qs, postObj, options)
      .map(
        (response: Response) => {
          return response.json();
        }).subscribe(
          (response: any) => {
            var responseInfo = new iResponseInfo();

            if (response != null) {
              responseInfo = response.responseInfo;

              if (responseInfo.isError) {
                this.errorMessage = responseInfo.message;
              }
            } else {
              this.user.isAgreed = true;
              this.lsService.setCurrentUser(this.user)
              this.router.navigate(['/search']);
            }

          },
          (error) => {
            this.errorMessage = error;
          });
  }

  hasErrors() {
    return this.errorMessage != null;
  }

  getErrorMessage() {
    return this.hasErrors() ? this.errorMessage : "";
  }

  getToken() {
    return this.lsService.getToken();
  }

  getUser(): iUser {
    if (tokenNotExpired()) {
      return (<iUser>this.lsService.getCurrentUser());
    }

    return null;
  }

  getUserName() {
    let usr: iUser = this.getUser();
    if (usr == null) {
      return "";
    }
    else {
      if (usr.firstName == null) {
        return usr.userName;
      }
      else {
        return usr.firstName + " " + usr.lastName;
      }
    }
  }


  refreshToken() {
    let headers = new Headers({ 'Authorization': 'Bearer ' + this.getToken() });
    let options = new RequestOptions({ headers: headers });

    const qs = environment.apiPath + '/api/auth/refreshToken';

    return this.http.get(qs, options)
      .map(
        (response: Response) => {
          return response.json();
        })
      .subscribe(
        (token: any) => {
          if (token == null || token.token == null || token.token == "") {
            this.logout();
          } else {
            this.lsService.setToken(token.token);
          }
        },
        (error: Error) => {
          this.logout();
        });
  }

  logout() {
    this.user = null;
    this.errorMessage = null;
    this.lsService.removeCurrentUser();
    this.authenticationChanged.next();
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/auth/auth.service.ts